<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="config-list"
            :url="url"
            :columns="columnList"
            dialogWidth="50%"
            :addButton="{ enabled: false }"
            :tableHeight="tableHeight"
            :filterSpan="[18, 5]"
            :updateButton="{ enabled: true }"
            :showSequence="false"
        >
        </crud-facecade>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `BoardConfig`,
    props: {},
    data() {
        return {
            title: `大屏显示配置`,
            noticeTitle: ``,
            rdate: this.$moment().format(`YYYY/MM/DD`),
            url: {
                baseURL: `/api/AcisSystem/BoardConfig`,
                get: () => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/BoardConfig/Get`)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                }
            }
        }
    },
    created() {},
    computed: {
        ...mapGetters([`screenHeight`, `active_ward`, `sys_enums`, `section_auth`, `operation_ward_auth`, `routers`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `display_order`,
                    label: `排序`,
                    isListable: true,
                    readonly: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `value`,
                    label: `字段值`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `显示列名`,
                    isListable: true,
                    isEditable: true,
                    searchable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `type`,
                    label: `大屏类型`,
                    isListable: true,
                    searchable: true,
                    options: [
                        { value: 0, label: `家属屏` },
                        { value: 1, label: `排程屏` },
                        { value: 2, label: `产科家属屏` }
                    ]
                },
                {
                    type: `string`,
                    prop: `width`,
                    label: `显示宽度`,
                    isListable: true,
                    isEditable: true,
                    readonly: false,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `bool`,
                    prop: `is_show`,
                    label: `是否显示`,
                    isEditable: true,
                    isListable: true,
                    options: `enum_bool`,
                    default: true,
                    readonly: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `display_back_color`,
                    label: `列背景色`,
                    isListable: true,
                    isEditable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `header_style`,
                    label: `表头样式`,
                    isListable: true,
                    isEditable: true,
                    readonly: false
                },
                {
                    type: `string`,
                    prop: `column_style`,
                    label: `列样式样式`,
                    isListable: true,
                    isEditable: true,
                    readonly: false
                },
                {
                    type: `bool`,
                    prop: `is_roll`,
                    label: `信息滚动`,
                    isEditable: true,
                    isListable: true,
                    options: `enum_bool`,
                    default: false,
                    readonly: false,
                    searchable: true
                },
                {
                    type: `select`,
                    prop: `is_split`,
                    label: `分屏`,
                    isListable: true,
                    isEditable: true,
                    searchable: true,
                    options: [
                        { value: 0, label: `不分屏` },
                        { value: 1, label: `上屏` },
                        { value: 2, label: `下屏` }
                    ]
                }
            ]
        }
    },
    mounted() {},
    methods: {},
    watch: {},
    destroyed() {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Board/BoardConfig.vue